// 🎨 STYLE SWITCH
const STYLE = "minimal"; // "minimal" | "bold" | "luxury"

const TIMELINE_STYLE = "hybrid"; // "minimal" | "visual" | "hybrid"

// console.log("FX LOADED");

// ---------- INIT ----------
function fxTransit(zip) {
  if (!zip) return [3,5];

  const first = parseInt(zip[0]);

  if (first <= 3) return [1,2];
  if (first <= 6) return [2,3];
  return [3,4];
}

function runFX() {
  document.querySelectorAll(".fx-app").forEach(el => { 
    if (!el.classList.contains("fx-loaded")) {
      initFX(el);
      el.classList.add("fx-loaded");
    }
  });
}

document.addEventListener("DOMContentLoaded", runFX);
document.addEventListener("shopify:section:load", runFX);
setTimeout(runFX, 500);

// ---------- MAIN ----------
function initFX(container) {

  const config = {
    enableZip: container.dataset.zip === "true",
    enableIP: container.dataset.ip === "true",
    enableTimer: container.dataset.timer === "true",
    enableInventory: container.dataset.inventory === "true",
    origin: container.dataset.origin || "28348",
    cutoff: parseInt(container.dataset.cutoff || 14),
    carrier: container.dataset.carrier || "ups",
    urgency: container.dataset.urgency === "true",
  };

  container.innerHTML = `
    <div class="fx-card">
      <div class="fx-main"></div>

      ${config.enableZip ? `
        <div class="fx-zip-row">
          <input class="fx-zip" placeholder="Enter ZIP code" maxlength="5">
          <button class="fx-btn">Check</button>
        </div>
      ` : ""}
    </div>
  `;

function getProgressPercent(now, cutoff) {
  const hours = now.getHours() + now.getMinutes() / 60;

  // Before cutoff → early stage
  if (hours < cutoff) {
    return 0.3 + (hours / cutoff) * 0.3;
  }

  // After cutoff → shipping + transit
  return 0.6 + ((hours - cutoff) / (24 - cutoff)) * 0.3;
}

function buildTimeline(now, early, cutoff) {

  const shipped = now.getHours() >= cutoff;
  const delivered = isTomorrow(early);

  let statusText = "";

  if (!shipped) {
    statusText = "📦 Preparing shipment";
  } else if (!delivered) {
    statusText = "🚚 In transit";
  } else {
    statusText = "📬 Out for delivery";
  }

  return `
  <div class="fx-timeline">

    <div class="fx-progress">
      <div class="fx-progress-bar" style="width:${getProgressPercent(now, cutoff) * 100}%"></div>
    </div>

    <div class="fx-steps fx-hybrid">
      
      <div class="fx-step active">
        <div class="fx-dot"></div>
        <div class="fx-label">Processing</div>
      </div>

      <div class="fx-step ${shipped ? "active" : ""}">
        <div class="fx-dot"></div>
        <div class="fx-label">
          ${shipped ? "In Transit" : "Shipped"}
        </div>
      </div>

      <div class="fx-step ${delivered ? "active" : ""}">
        <div class="fx-dot"></div>
        <div class="fx-label">Delivered</div>
      </div>

    </div>

    <div class="fx-live-status">
      ${statusText}
    </div>
  `;
}

  // 🎨 APPLY STYLE
  container.classList.add("fx-card");
  if (STYLE === "minimal") container.classList.add("fx-minimal");
  if (STYLE === "bold") container.classList.add("fx-bold");
  if (STYLE === "luxury") container.classList.add("fx-luxury");

  const main = container.querySelector(".fx-main");
  const zipInput = container.querySelector(".fx-zip");
  const btn = container.querySelector(".fx-btn");

  // 📱 MOBILE ZIP HIDE
  function toggleZip() {
    if (!zipInput) return;
    zipInput.parentElement.style.display =
      window.innerWidth < 768 ? "none" : "flex";
  }

  toggleZip();
  window.addEventListener("resize", toggleZip);

  if (btn) btn.onclick = render;

  // ---------- HELPERS ----------
  function addBizDays(date, days) {
    let d = new Date(date), added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  }

  function countdown() {
    if (!config.enableTimer) return "";
    const now = new Date();
    const cut = new Date();
    cut.setHours(config.cutoff, 0, 0, 0);

    if (now > cut) return "⏱ Ships next business day";

    const diff = cut - now;
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff / 60000) % 60);
    return `⏱ Order within <strong>${h}h ${m}m</strong>`;
  }

  function transit(zip) {
  if (!zip) return [5,10];

  const first = parseInt(zip[0]);

  if (first <= 3) return [5,7];
  if (first <= 6) return [6,9];
  return [7,12];
}

  async function detect() {
    if (!config.enableIP) return null;
    try {
      const r = await fetch("https://ipapi.co/json/");
      return await r.json();
    } catch {
      return null;
    }
  }

  function isTomorrow(date) {
    const t = new Date();
    t.setDate(t.getDate() + 1);
    return date.toDateString() === t.toDateString();
  }

  // ---------- RENDER ----------
async function render() {

  main.innerHTML = `<span style="color:#64748b;">Checking delivery...</span>`;

  let zip = zipInput?.value?.trim();

  const supplier = container.dataset.supplier || "standard";

  if (!zip) {
    const location = await detect();
    if (location?.postal) {
      zip = location.postal.substring(0, 5);
      if (zipInput) zipInput.value = zip;
    }
  }

 if (zip && !/^\d{5}$/.test(zip)) {
  zip = null;
}

  if (zip) {
    localStorage.setItem("fx-zip", zip);
  }

    const now = new Date();

    if (now.getHours() >= config.cutoff) {
      now.setDate(now.getDate() + 1);
    }

    while (now.getDay() === 0 || now.getDay() === 6) {
      now.setDate(now.getDate() + 1);
    }

    const ship = addBizDays(now, 1);

    let baseMin, baseMax;

// Supplier base
if (supplier === "us") {
  [baseMin, baseMax] = [4,7];
} else if (supplier === "intl") {
  [baseMin, baseMax] = [7,12];
} else {
  [baseMin, baseMax] = [5,10];
}

// ✅ SAFE ZIP LOGIC
let zipMin = 3, zipMax = 5;

if (zip && /^\d{5}$/.test(zip)) {
  const result = transit(zip);
  if (Array.isArray(result)) {
    zipMin = result[0];
    zipMax = result[1];
  }
}

// ✅ SAFE COMBINE
const minT = Math.max(baseMin, zipMin);
const maxT = Math.max(baseMax, zipMax);

// ✅ 👉 ADD THIS RIGHT HERE
const early = addBizDays(ship, minT);
const late = addBizDays(ship, maxT);

    let arrivalText = "";

    if (isTomorrow(early)) {
      arrivalText = `<span class="fx-highlight fx-animate">🟢 Arrives Tomorrow</span>`;
    } else {
      arrivalText = `<span class="fx-arrival">Arrives ${fmt(early)} – ${fmt(late)}</span>`;
    }

    let inventoryText = "";

    if (config.enableInventory && typeof window.fxInventory !== "undefined") {
      if (window.fxInventory <= 3) {
        inventoryText = `Only ${window.fxInventory} left`;
      }
    }

  const icons = {
  truck: `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M3 7h13v8H3z" stroke="currentColor" stroke-width="1.5"/>
      <path d="M16 10h3l2 2v3h-5z" stroke="currentColor" stroke-width="1.5"/>
    </svg>
  `,
  bolt: `
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"/>
    </svg>
  `
};

main.innerHTML = `
  <div class="fx-title">${icons.truck} Estimated Delivery</div>

  <div class="fx-line">${arrivalText}</div>

  <div class="fx-line fx-shipping-note">Fast US Shipping</div>

  ${buildTimeline(now, early, config.cutoff)}

  ${inventoryText ? `
    <div class="fx-line fx-warning">
      ${icons.bolt} ${inventoryText}
    </div>
  ` : ""}

  <div class="fx-line fx-timer">${countdown()}</div>
`;
  }

  render();
  setInterval(render, 60000);
}

// ---------- STICKY BAR ----------
function initStickyBar() {
  const buyButton = document.querySelector('[name="add"]');
  if (!buyButton) return;

  const bar = document.createElement("div");
  bar.className = "fx-sticky-bar";

  function updateBar() {
    const now = new Date();
    const cutoff = 14;

    let text = "";

    if (now.getHours() < cutoff) {
      text = "⚡ Order now — Ships Today";
    } else {
      text = "📦 Ships next business day";
    }

    bar.innerHTML = text;
  }

  updateBar();
  setInterval(updateBar, 60000);

  document.body.appendChild(bar);

  const observer = new IntersectionObserver(([entry]) => {
    bar.classList.toggle("show", !entry.isIntersecting);
  });

  observer.observe(buyButton);
}

document.addEventListener("DOMContentLoaded", initStickyBar);

// ---------- CART DELIVERY (CLEAN + FIXED) ----------
(function(){

  function injectCartDelivery() {

    const cartContainer = document.querySelector(
      ".cart-drawer__inner, .drawer__inner, .cart-drawer"
    );

    if (!cartContainer) return;

    let el = cartContainer.querySelector(".fx-cart-delivery");

    if (!el) {
      el = document.createElement("div");
      el.className = "fx-cart-delivery";
      cartContainer.prepend(el);
    }

    const now = new Date();
    const cutoff = 14;

    let zip = localStorage.getItem("fx-zip");

   function transit(zip, origin = "28348", carrier = "ups") {
  if (!zip) return [3, 5];

  const distance = Math.abs(parseInt(zip) - parseInt(origin));

  if (carrier === "ups") {
    if (distance < 200) return [1, 2];
    if (distance < 800) return [2, 3];
    return [3, 5];
  }

  if (carrier === "usps") {
    if (distance < 200) return [2, 3];
    if (distance < 800) return [3, 4];
    return [4, 6];
  }

  return [3, 5];
}

const [minT, maxT] = transit(zip);

    let text = "";

    if (minT === 1 && now.getHours() < cutoff) {
  text = "🟢 Arrives Tomorrow";
} else if (minT <= 3) {
  text = "⚡ Fast Delivery";
} else {
  text = `📦 ${minT}–${maxT} Day Delivery`;
}

    el.innerHTML = text;
  }

  // 🔥 RUN WHEN USER INTERACTS
  document.addEventListener("click", () => {
    setTimeout(injectCartDelivery, 200);
  });

})();

// ---------- GRID BADGES ----------
function initGridBadges() {

  document.querySelectorAll(".fx-grid-badge").forEach(async (el) => {

    const now = new Date();
    const cutoff = 14;

    // Try to get ZIP (same logic as main card)
    let zip = localStorage.getItem("fx-zip");

    if (!zip) {
      try {
        const r = await fetch("https://ipapi.co/json/");
        const data = await r.json();
        zip = data?.postal?.substring(0,5);
      } catch {}
    }

    // Transit logic (same as your main function)
    const [minT, maxT] = fxTransit(zip);

    const isBeforeCutoff = now.getHours() < cutoff;

    let text = "";
    let type = "";

    // 🎯 MATCH MAIN DELIVERY LOGIC
    if (minT <= 1 && isBeforeCutoff) {
      text = "Arrives Tomorrow";
      type = "tomorrow";
    } else if (minT <= 2) {
      text = "Fast Delivery";
      type = "fast";
    } else {
      text = `${minT}–${maxT} Day Delivery`;
      type = "standard";
    }

    el.innerHTML = `<span class="fx-badge fx-${type}">${text}</span>`;

    // ✨ Animate in
    requestAnimationFrame(() => {
      el.classList.add("fx-badge-show");
    });

  });
}

document.addEventListener("DOMContentLoaded", initGridBadges);
document.addEventListener("shopify:section:load", initGridBadges);

// ---------- STYLES ----------
const style = document.createElement("style");
style.innerHTML = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

:root {
  --fx-primary: #0f172a;        /* title (dark slate) */
  --fx-brand: #01E5EE;          /* Fastronix cyan */
  --fx-accent: #22c55e;         /* delivery green */
  --fx-text: #0f172a;
  --fx-muted: #64748b;
  --fx-border: #e5e7eb;
  --fx-glow: rgba(1,229,238,0.25);
}

.fx-card {
  font-family: 'Inter', sans-serif;
  border-radius: 12px;
  padding: 14px;
}

.fx-card {
  transition: all 0.25s ease;
}

.fx-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.06);
}

.fx-minimal {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.fx-minimal:hover {
  border-color: #d1d5db;
}

.fx-bold {
  background: #dcfce7;
}

.fx-luxury {
  background: linear-gradient(#fff,#f9fafb);
  box-shadow: 0 4px 20px rgba(0,0,0,0.04);
}

.fx-title {
  font-weight: 600;
  color: var(--fx-primary);
}

.fx-highlight {
  font-weight: 600;
  color: var(--fx-primary);
}

.fx-warning {
  color: #dc2626;
}

.fx-timer {
  color: var(--fx-muted);
  font-size: 12px;
}

.fx-line {
  margin-top: 6px;
}

.fx-zip {
  flex: 1;
  padding: 8px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db; /* darker, cleaner */
  background: #fff;
  color: var(--fx-text);
  transition: border 0.2s ease;
}

.fx-zip:focus {
  outline: none;
  border-color: var(--fx-primary);
  box-shadow: 0 0 0 2px rgba(1,229,238,0.15);
}

.fx-btn {
  padding: 8px 12px;
  font-size: 12px;
  background: #111827;
  color: #fff;
  border-radius: 6px;
  border: 1px solid #111827;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.fx-btn:hover {
  background: #1f2937;
}

.fx-shipping-note {
  font-size: 12px;
  color: var(--fx-muted);
}

@keyframes fxPulse {
  0% {transform: scale(1);}
  50% {transform: scale(1.03);}
  100% {transform: scale(1);}
}

.fx-animate {
  animation: fxPulse 1.8s infinite;
}

/* PROGRESS BAR */
.fx-progress {
  position: relative;
  margin-top: 10px;
  height: 4px;
  background: rgba(0,0,0,0.05);
  border-radius: 999px;
  overflow: hidden;
}

.fx-progress-bar {
  position: relative;
  height: 100%;
  width: 0;

  /* ✅ Brand gradient */
  background: linear-gradient(90deg, var(--fx-brand), var(--fx-accent));

  border-radius: 999px;

  /* ✅ Smooth updates */
transition: width 0.8s cubic-bezier(0.22, 1, 0.36, 1);

  /* ✅ Initial animation */
  animation: fxLoad 0.8s ease;
}

.fx-progress-bar::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255,255,255,0.35),
    transparent
  );
  animation: fxShimmer 2s infinite;
}

@keyframes fxShimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.fx-timeline {
  display: flex;
  flex-direction: column;
  gap: 10px; /* 👈 THIS creates clean spacing */
}

.fx-sticky-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #111827;
  color: #fff;
  text-align: center;
  padding: 10px;
  font-size: 13px;
  transform: translateY(100%);
  transition: transform 0.3s ease;
  z-index: 999;
}

.fx-sticky-bar.show {
  transform: translateY(0);
}

.fx-cart-delivery {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 500;
  color: var(--fx-primary);
}

.fx-grid-badge {
  font-size: 12px;
  color: var(--fx-primary);
  font-weight: 600;
  margin-top: 4px;
}

.fx-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 999px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  transform: translateY(0);
  will-change: transform;
}

/* ✅ LIGHTWEIGHT HOVER */
.fx-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.06);
}

/* VARIANTS */
.fx-tomorrow {
  background: rgba(34,197,94,0.12);
  color: #16a34a;
}

.fx-fast {
  background: rgba(1,229,238,0.12);
  color: var(--fx-primary);
}

.fx-tomorrow:hover {
  box-shadow: 0 0 0 2px rgba(34,197,94,0.15);
}

.fx-fast:hover {
  box-shadow: 0 0 0 2px rgba(1,229,238,0.15);
}

.fx-standard {
  background: rgba(0,0,0,0.06);
  color: var(--fx-muted);
}

/* ANIMATION */
.fx-grid-badge {
  opacity: 0;
  transform: translateY(4px);
  transition: all 0.4s ease;
}

.fx-grid-badge.fx-badge-show {
  opacity: 1;
  transform: translateY(0);
}

.fx-btn:active {
  transform: scale(0.98);
}

/* ---------- MICRO-INTERACTIONS ---------- */

/* CARD FADE-IN */
.fx-card {
  animation: fxFadeIn 0.4s ease;
}

@keyframes fxFadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* PROGRESS BAR POLISH */
.fx-progress-bar {
  filter: saturate(1.1);
}

/* LIVE STATUS FADE */
.fx-live-status {
  animation: fxFadeIn 0.5s ease;
}

/* BUTTON MICRO-FEEDBACK */
.fx-btn {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.fx-btn:hover {
  transform: translateY(-1px);
}

.fx-btn:active {
  transform: scale(0.97);
}

@keyframes fxLoad {
  from { width: 0; }
  to { width: 100%; }
}

/* STEPS */
.fx-steps {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.fx-step {
  text-align: center;
  flex: 1;
  }

.fx-dot {
  width: 8px;
  height: 8px;
  background: #d1d5db;
  border-radius: 50%;
  margin: 0 auto;
  transition: all 0.3s ease;
}

.fx-step.active .fx-dot {
  background: var(--fx-primary);
  transform: scale(1.2);
  margin-top: 6px;
}

/* LABELS (visual mode only) */
.fx-label {
  font-size: 10px;
  color: var(--fx-muted);
}

/* HYBRID */
.fx-hybrid .fx-step {
  position: relative;
}

.fx-hybrid .fx-dot {
  box-shadow: 0 0 0 2px rgba(1,229,238,0.15);
}

.fx-hybrid .fx-label {
  font-size: 10px;
  color: var(--fx-muted);
  margin-top: 6px;
  text-align: center;
}
`;

if (!document.querySelector("#fx-delivery-styles")) {
  style.id = "fx-delivery-styles";
  document.head.appendChild(style);
}